export const user = Array.from(
  new Set([
    'user:write',
    'user:read',
    'category:read',
    'type:read',
    'resource:read',
    'organisation:read',
    'activity:read',
    'comment:read',
    'comment:write',
    'report:write',
    'feed:read',
  ])
);
export const admin = Array.from(
  new Set([...user, 'organisation:write', 'organisation:read'])
);
export const superuser = Array.from(
  new Set([
    ...user,
    ...admin,
    'membership:write',
    'category:write',
    'type:write',
    'organisation:write',
    'resource:write',
    'activity:write',
    'report:read',
  ])
);
